import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */

export function sumValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const total = control.value;
  let construction_elements: number[] = [];
  let isError: boolean = false;
  let message: string = '';

  if (!total || isNaN(Number(total))) {
    return null;
  }

  if (total < 100) {
    isError = true;
    message = 'Total shouldnot be less than 100';
  } else if (total > 100) {
    isError = true;
    message = 'Total should not be greater than 100';
  } else {
    isError = false;
  }

  return isError
    ? {
        sum: {
          message: (options?.data?.message ? options.data.message : message),
        },
      }
    : null;
}

